import React from 'react'

const Mobile = () => {
  /* eslint-disable max-len */
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g transform="translate(5 2)" fill="none" fillRule="evenodd">
        <path
          d="M2 0h10c1.333 0 2 .667 2 2v16c0 1.333-.667 2-2 2H2c-1.333 0-2-.667-2-2V2C0 .667.667 0 2 0z"
          stroke="#9CA4AF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect fill="#9CA4AF" x="6" y="15.333" width="2" height="2" rx="1" />
      </g>
    </svg>
  )
  /* eslint-enable */
}

export default Mobile
